import { render, staticRenderFns } from "./Directions.vue?vue&type=template&id=324dd22a&scoped=true&"
import script from "./Directions.vue?vue&type=script&lang=js&"
export * from "./Directions.vue?vue&type=script&lang=js&"
import style0 from "./Directions.vue?vue&type=style&index=0&id=324dd22a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324dd22a",
  null
  
)

export default component.exports